import React, { useState, useEffect, useRef } from 'react';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';

import SentimentEvolution from './SentimentEvolution';
import SentimentByCountry from './SentimentByCountry';
import EmptyMessageComponent from '../EmptyMessageComponent';
import ClientPlanManagementComponent from '../Client Management/ClientPlanManagementComponent';

import { cardStyles } from '../../styles/cardStyles';

import { Select, Option, Stack, Typography, Card, Alert, Box, Divider, Button, Modal, ModalOverflow, ModalDialog, ModalClose, DialogTitle, DialogContent } from '@mui/joy';
import { Star, Timeline, BarChart, TrendingUp, Public, Mood, Schedule, ScatterPlot } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlay, faAppStore } from '@fortawesome/free-brands-svg-icons'

import RatingDistributionGraph from './RatingDistributionComponent';
import RatingEvolutionGraph from './RatingEvolutionComponent';
import WingmanRating from '../Wingman/WingmanRating';
import SentimentEvolutionOverTime from './SentimentEvolutionOverTime';
import WingmanSentiment from '../Wingman/WingmanSentiment';
import ReviewsByVersion from './ReviewsByVersion';
import ScatterPlotSentiment from './ScatterPlotSentiment';
import Rating from "@mui/material/Rating";

import DateFilter, { DateFilterValue } from '../Filters/DateFilter';
import { getDateRange } from '../../Helpers/DateHelpers';
import { useAuth } from '../../context/authContext';
import InfoTooltipComponent from '../InfoTooltipComponent';

const networking = require('../../Networking/API');
const hbHelper = require('../../Helpers/heartbeatDataHandler');
const helper = require('../../Helpers/helpers');

function HeartBeatComponent({ subscription, app }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [reviews, setReviews] = useState(null) as any[];
    const [showPlanSettings, setShowPlanSettings] = useState(false);

    //Filter states
    const [currentStore, setCurrentStore] = useState('All Stores');
    const [currentSentiment, setCurrentSentiment] = useState('All Sentiments');
    const [currentRating, setCurrentRating] = useState<number>(5);
    const [currentTerritoryCode, setCurrentTerritoryCode] = useState('All Countries');
    const [selectedFilter, setSelectedFilter] = useState<DateFilterValue>("last7");

    const hasFetched = useRef(false);
    const { start, end } = getDateRange(selectedFilter);

    useEffect(() => {
        if (!hasFetched.current) {
            getData();
            hasFetched.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function getData() {
        networking.reviewsFor(app.id, token).then((reviews: any) => {
            setLoading(false);

            setReviews(reviews);

        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function filterByStore(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentStore(value)
    }

    function filterBySentiment(e: any) {
        e.preventDefault();

        const value = e.target.innerText.trim();

        setCurrentSentiment(value)
    }

    function filterByTerritoryCode(e: any, newValue: any) {
        e?.preventDefault();

        const value = newValue || e?.target?.innerText;

        setCurrentTerritoryCode(value)
    }

    var currentItems = reviews && reviews.filter((r: any) => r.store !== 'profeed');
    var territories: any[] = [];

    if (currentItems) {
        // Extract territories for dropdown
        territories = [...new Set(currentItems.map((r: any) => r.territorycode).filter(Boolean))];
        territories.sort();
        territories.unshift("All Countries");

        if (currentStore === 'Appstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'applestore');

        } else if (currentStore === 'Playstore') {
            currentItems = currentItems.filter((r: any) => r.store === 'playstore');

        }

        currentItems = currentItems.filter((r: Review) => Number(r.rating) <= currentRating);

        if (currentSentiment !== 'All Sentiments') {
            currentItems = currentItems.filter((r: Review) => r.sentiment.toLowerCase() === currentSentiment.toLowerCase());
        }

        if (currentTerritoryCode !== 'All Countries') {
            currentItems = currentItems.filter((r: any) => r.territorycode === currentTerritoryCode);
        }

        //Apply Date filters
        currentItems = currentItems.filter((review: Review) => {
            const reviewDate = new Date(review.updated);
            return (!start || reviewDate >= start) && (!end || reviewDate <= end);
        });
    }

    const updateSubscription = (subscription: any) => {
    }

    return (
        <div >
            {loading ?
                <LoadingSpinnerComponent />
                :
                <div className='col'>
                    {/* Plan Modal */}
                    <Modal
                        open={showPlanSettings}
                        onClose={() => setShowPlanSettings(false)}>
                        <ModalOverflow>
                            <ModalDialog
                                color="neutral"
                                size="sm"
                                variant="plain">
                                <ModalClose />
                                <DialogTitle>
                                    Plans & Billing
                                </DialogTitle>
                                <DialogContent>
                                    Upgrade your plan to reply to reviews.
                                </DialogContent>
                                <div className='pt-4'>
                                    <ClientPlanManagementComponent
                                        subscription={subscription}
                                        onSubscriptionUpdate={updateSubscription}
                                    />
                                </div>
                            </ModalDialog>
                        </ModalOverflow>
                    </Modal>
                    {/* Filters and Actions */}
                    <Box
                        component='section'
                        color='primary'
                        sx={{
                            marginBottom: 2,
                        }}>
                        <div className='row g-2'>
                            <div className='col'>
                            </div>
                            <div className='col-auto'>
                                <Select
                                    color="neutral"
                                    defaultValue={'all'}
                                    size="sm"
                                    variant="outlined"
                                    onChange={filterByStore}
                                    sx={{
                                        borderRadius: '10px',
                                        padding: '0 12px',
                                        height: '30px',
                                        backgroundColor: '#ffffff',
                                        fontSize: '12px',
                                    }}>
                                    <Option value="all">
                                        <span className="me-2"><FontAwesomeIcon icon={faStore} /></span>
                                        All Stores
                                    </Option>
                                    <Option value="apple">
                                        <span className="me-2"><FontAwesomeIcon icon={faAppStore} />
                                        </span> Appstore
                                    </Option>
                                    <Option value="google"><span className="me-2">
                                        <FontAwesomeIcon icon={faGooglePlay} /></span> Playstore
                                    </Option>
                                </Select>
                            </div>
                            <div className='col-auto'>
                                <Select
                                    color="neutral"
                                    defaultValue={'all'}
                                    size="sm"
                                    variant="outlined"
                                    onChange={filterBySentiment}
                                    sx={{
                                        borderRadius: '10px',
                                        padding: '0 12px',
                                        height: '30px',
                                        backgroundColor: '#ffffff',
                                        fontSize: '12px',
                                    }}>
                                    <Option value="all">
                                        All Sentiments
                                    </Option>
                                    <Option value="good">
                                        Good
                                    </Option>
                                    <Option value="neutral">
                                        Neutral
                                    </Option>
                                    <Option value="bad">
                                        Bad
                                    </Option>
                                </Select>
                            </div>
                            <div className='col-auto'>
                                <Select
                                    value={currentRating || 5}
                                    color="neutral"
                                    size="sm"
                                    variant="outlined"
                                    placeholder="Filter by rating"
                                    onChange={(_, newValue) => setCurrentRating(newValue ?? 5)}
                                    renderValue={(selected) =>
                                        selected ? (
                                            <Stack direction="row" spacing={1} alignItems="center">
                                                <Rating
                                                    value={Number(selected.value)}
                                                    readOnly size="small"
                                                    emptyIcon={<Star
                                                        style={{ opacity: 0.55 }}
                                                        fontSize="inherit" />} />
                                            </Stack>
                                        ) : (
                                            "Filter by rating"
                                        )
                                    }
                                    sx={{
                                        borderRadius: '10px',
                                        padding: '0 12px',
                                        height: '30px',
                                        backgroundColor: '#ffffff',
                                        fontSize: '12px',
                                    }}>
                                    {[5, 4, 3, 2, 1].map((rating) => (
                                        <Option
                                            key={rating}
                                            value={rating}>
                                            <Stack direction="row"
                                                spacing={1}
                                                alignItems="center">
                                                <Rating
                                                    value={rating}
                                                    readOnly size="small"
                                                    emptyIcon={<Star
                                                        style={{ opacity: 0.55 }}
                                                        fontSize="inherit" />} />
                                            </Stack>
                                        </Option>
                                    ))}
                                </Select>
                            </div>
                            <div className='col-auto'>
                                <Select
                                    color="neutral"
                                    placeholder="All countries"
                                    size="sm"
                                    variant="outlined"
                                    onChange={(_, newValue) => filterByTerritoryCode(null, newValue)}
                                    sx={{
                                        borderRadius: '10px',
                                        padding: '0 12px',
                                        height: '30px',
                                        backgroundColor: '#ffffff',
                                        fontSize: '12px',
                                    }}>
                                    {
                                        territories.map((territory: string) => {
                                            return (
                                                <Option key={territory} value={territory}>
                                                    {territory === 'All Countries' ? territory : helper.getCountryName ? helper.getCountryName(territory) : territory}
                                                </Option>
                                            );
                                        })
                                    }
                                </Select>
                            </div>
                            <div className='col-auto'>
                                <DateFilter
                                    selectedFilter={selectedFilter}
                                    onChange={setSelectedFilter} />
                            </div>
                        </div>
                    </Box>
                    {
                        currentItems && currentItems.length === 0 &&
                        <Card
                            sx={{
                                ...cardStyles.base
                            }}>
                            <EmptyMessageComponent
                                title={'We were not able to generate your heartbeat.'}
                                description={'We\'ve not found any reviews. Please try another search criteria.'} />
                        </Card>
                    }
                    {currentItems && currentItems.length !== 0 &&
                        <>
                            {app && subscription && (subscription.plan === 'AAA' || subscription.plan === 'U') &&
                                <WingmanRating
                                    app={app}
                                    data={
                                        [hbHelper.getRatingOverTimeWingman(currentItems),
                                        hbHelper.getRatingOverVersionWingman(currentItems),
                                        hbHelper.getRatingDistributionWingman(currentItems)]} />
                            }
                            {app && subscription && (subscription.plan === 'AA') &&
                                <Alert
                                    className="mb-3"
                                    size="lg"
                                    variant="soft"
                                    color="primary"
                                    endDecorator={
                                        <Button
                                            size="sm"
                                            variant="soft"
                                            color="primary"
                                            onClick={() => setShowPlanSettings(true)}
                                        >
                                            See plans
                                        </Button>
                                    }
                                >
                                    <div>
                                        <strong>Activate the Wingman</strong>
                                        <Typography level="body-sm">
                                            Wingman provides clear, practical guidance and smart summaries of user reviews to help you improve your app based on real feedback.
                                        </Typography>
                                        <Typography level="body-sm">
                                            This feature is available on the <b>Growth</b> and <b>Premium</b> plans.
                                        </Typography>
                                    </div>
                                </Alert>
                            }

                            <div className='mb-3'>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        ...cardStyles.base
                                    }}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <Timeline sx={{ color: '#3b82f6', fontSize: '1.1rem' }} />
                                        <Typography
                                            color='neutral'
                                            fontWeight={600}
                                            level='body-xs'>
                                            {"Reviews timeline".toUpperCase()}
                                            <InfoTooltipComponent
                                                message={"The reviews timeline shows the number of reviews received over time, allowing you to track user feedback trends and identify periods of increased or decreased engagement."}
                                                size={'sm'}
                                                variant={'plain'}
                                                color={'primary'} />
                                        </Typography>
                                    </Stack>
                                    <Divider />
                                    <Typography
                                        color='primary'
                                        fontWeight={300}
                                        level='h2'>
                                        {currentItems.length}
                                        <span>
                                            <Typography
                                                color='neutral'
                                                level='body-xs'>
                                                {" Reviews"}
                                            </Typography>
                                        </span>
                                        <span>
                                            <Typography
                                                color='neutral'
                                                fontWeight={400}
                                                level='body-xs'>
                                                {" (avg " + (currentItems.length / hbHelper.aggregateReviewsByDate(currentItems).seriesData.length).toFixed(0) + " per day)"}
                                            </Typography>
                                        </span>
                                    </Typography>
                                    <Divider />
                                    {currentItems &&
                                        <ReviewsByVersion
                                            data={hbHelper.aggregateReviewsByDate(currentItems).seriesData}
                                            annotations={hbHelper.getVersionAnnotations(currentItems)} />}
                                </Card>
                            </div>
                            <div className='row gx-2 mt-3'>
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white',
                                            border: '1px solid #f1f5f9',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <TrendingUp sx={{ color: '#f59e0b', fontSize: '1.1rem' }} />
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Average rating".toUpperCase()}
                                                <InfoTooltipComponent
                                                    message={"Track how the average rating from written reviews evolves across app versions, helping you measure user satisfaction and assess the impact of each release."}
                                                    size={'sm'}
                                                    variant={'plain'}
                                                    color={'primary'} />
                                            </Typography>
                                        </Stack>
                                        <Divider />
                                        <Typography
                                            color='primary'
                                            fontWeight={300}
                                            level='h2'
                                            sx={{ ml: 3 }}>
                                            {helper.calculateAverageRating(currentItems)}
                                            <span>
                                                <Typography
                                                    color='neutral'
                                                    level='body-xs'>
                                                    {" Average Rating"}
                                                </Typography>
                                            </span>
                                        </Typography>
                                        <Divider />
                                        {reviews &&
                                            <RatingEvolutionGraph
                                                type="bar"
                                                data={hbHelper.getRatingOverVersion(currentItems)} />}
                                    </Card>
                                </div>
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white',
                                            border: '1px solid #f1f5f9',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <BarChart sx={{ color: '#3b82f6', fontSize: '1.1rem' }} />
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Rating breakdown".toUpperCase()}
                                                <InfoTooltipComponent
                                                    message={"Shows how reviews are distributed across rating levels and how they contribute to the overall average rating."}
                                                    size={'sm'}
                                                    variant={'plain'}
                                                    color={'primary'} />
                                            </Typography>
                                        </Stack>
                                        <Divider />
                                        <Typography
                                            color='primary'
                                            fontWeight={300}
                                            level='h2'
                                            sx={{ ml: 3 }}>
                                            {helper.calculateAverageRating(currentItems)}
                                            <span>
                                                <Typography
                                                    color='neutral'
                                                    level='body-xs'>
                                                    {" Average Rating"}
                                                </Typography>
                                            </span>
                                        </Typography>
                                        <Divider />
                                        {currentItems &&
                                            <RatingDistributionGraph
                                                averageRating={helper.calculateAverageRating(currentItems)}
                                                data={hbHelper.getRatingDistribution(currentItems)} />}
                                    </Card>
                                </div>
                            </div>
                            <div className='mt-2'>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <Schedule sx={{ color: '#22c55e', fontSize: '1.1rem' }} />
                                        <Typography
                                            color='neutral'
                                            fontWeight={600}
                                            level='body-xs'>
                                            {"Average rating timeline".toUpperCase()}
                                            <InfoTooltipComponent
                                                message={"Tracks the average rating derived from written reviews, helping identify trends and shifts in user sentiment over time."}
                                                size={'sm'}
                                                variant={'plain'}
                                                color={'primary'} />
                                        </Typography>
                                    </Stack>
                                    <Divider />
                                    <Typography
                                        color='primary'
                                        fontWeight={300}
                                        level='h2'
                                        sx={{ ml: 3 }}>
                                        {helper.calculateAverageRating(currentItems)}
                                        <span>
                                            <Typography
                                                color='neutral'
                                                level='body-xs'>
                                                {" Average Rating"}
                                            </Typography>
                                        </span>
                                    </Typography>
                                    <Divider />
                                    {currentItems &&
                                        <RatingEvolutionGraph
                                            type="line"
                                            data={hbHelper.getRatingOverTime(currentItems)}
                                            annotations={hbHelper.getVersionAnnotations(currentItems)} />}
                                </Card>
                            </div>
                            {app && subscription && (subscription.plan === 'AAA' || subscription.plan === 'U') &&
                                <div className='mt-3'>
                                    <WingmanSentiment
                                        app={app}
                                        data={
                                            [hbHelper.getSentimentEvolutionOverVersionWingman(currentItems),
                                            hbHelper.getSentimentEvolutionOverTimeWingman(currentItems)]} />
                                </div>
                            }
                            {app && subscription && (subscription.plan === 'AA') &&
                                <Alert
                                    className="mb-3 mt-3"
                                    size="lg"
                                    variant="soft"
                                    color="primary"
                                    endDecorator={
                                        <Button
                                            size="sm"
                                            variant="soft"
                                            color="primary"
                                            onClick={() => setShowPlanSettings(true)}
                                        >
                                            See plans
                                        </Button>
                                    }
                                >
                                    <div>
                                        <strong>Activate the Wingman</strong>
                                        <Typography level="body-sm">
                                            Wingman provides clear, practical guidance and smart summaries of user reviews to help you improve your app based on real feedback.
                                        </Typography>
                                        <Typography level="body-sm">
                                            This feature is available on the <b>Growth</b> and <b>Premium</b> plans.
                                        </Typography>
                                    </div>
                                </Alert>
                            }
                            <div className='row gx-2 mt-3'>
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white',
                                            border: '1px solid #f1f5f9',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <Public sx={{ color: '#ef4444', fontSize: '1.1rem' }} />
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Sentiment by country".toUpperCase()}
                                                <InfoTooltipComponent
                                                    message={"Compare sentiment across countries based on written reviews, helping identify regional differences in user perception and satisfaction."}
                                                    size={'sm'}
                                                    variant={'plain'}
                                                    color={'primary'} />
                                            </Typography>
                                        </Stack>
                                        <Divider />
                                        {currentItems &&
                                            <SentimentByCountry
                                                data={hbHelper.getSentimentEvolutionByCountry(currentItems)} />}
                                    </Card>
                                </div>
                                <div className='col'>
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            backgroundColor: 'white',
                                            border: '1px solid #f1f5f9',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <Mood sx={{ color: '#8b5cf6', fontSize: '1.1rem' }} />
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Sentiment breakdown".toUpperCase()}
                                                <InfoTooltipComponent
                                                    message={"Compare the distribution of positive, negative, and neutral sentiment across app versions to understand how user feedback evolves with each release."}
                                                    size={'sm'}
                                                    variant={'plain'}
                                                    color={'primary'} />
                                            </Typography>
                                        </Stack>
                                        <Divider />
                                        {reviews &&
                                            <SentimentEvolution
                                                data={hbHelper.getSentimentEvolutionOverVersion(currentItems).seriesData} />}
                                    </Card>
                                </div>
                            </div>
                            <div className='mt-2'>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <Timeline sx={{ color: '#f97316', fontSize: '1.1rem' }} />
                                        <Typography
                                            color='neutral'
                                            fontWeight={600}
                                            level='body-xs'>
                                            {"Sentiment timeline".toUpperCase()}
                                            <InfoTooltipComponent
                                                message={"Track how positive, negative, and neutral sentiment from written reviews evolves over time, helping identify trends and shifts in user perception."}
                                                size={'sm'}
                                                variant={'plain'}
                                                color={'primary'} />
                                        </Typography>
                                    </Stack>
                                    <Divider />
                                    {currentItems &&
                                        <SentimentEvolutionOverTime
                                            data={hbHelper.getSentimentEvolutionOverTime(currentItems).seriesData}
                                            annotations={hbHelper.getVersionAnnotations(currentItems)} />}
                                </Card>
                            </div>

                            <div className='mt-2'>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                        <ScatterPlot sx={{ color: '#6366f1', fontSize: '1.1rem' }} />
                                        <Typography
                                            color='neutral'
                                            fontWeight={600}
                                            level='body-xs'>
                                            {"Sentiment distribution".toUpperCase()}
                                            <InfoTooltipComponent
                                                message={"Explore how individual written reviews are distributed across ratings and sentiment categories, helping uncover patterns in user feedback."}
                                                size={'sm'}
                                                variant={'plain'}
                                                color={'primary'} />
                                        </Typography>
                                    </Stack>
                                    <Divider />
                                    {currentItems &&
                                        <ScatterPlotSentiment
                                            data={currentItems} />}
                                </Card>
                            </div>
                        </>
                    }
                </div >
            }
        </div >
    );

}

export default HeartBeatComponent;